import { DependencyList, useLayoutEffect } from 'react';

/**
 * @description body 엘리먼트에 attribute 혹은 className 을 추가하거나 제거합니다.
 */
export const useBody = (
  {
    attributes,
    classNames,
  }: {
    attributes?: {
      name: string;
      value: string;
    }[];
    classNames?: string[];
  },
  deps?: DependencyList,
) => {
  useLayoutEffect(() => {
    if (!attributes) return;
    // document.body 는 문서 teardown/브라우저 번역 프록시의 body 교체 타이밍에 null 이 될 수 있다.
    // 언마운트 cleanup 이 그 순간 실행되면 removeAttribute 에서 크래시한다(PLAY-APP-AZG). 매 접근마다 옵셔널 체이닝으로 가드.
    attributes.forEach(({ name, value }) => {
      document.body?.setAttribute(name, value);
    });

    return () => {
      attributes.forEach(({ name }) => {
        document.body?.removeAttribute(name);
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  useLayoutEffect(() => {
    if (!classNames) return;
    classNames.forEach(className => {
      const hasClassName = document.body?.classList.contains(className);
      if (hasClassName) {
        document.body?.classList.remove(className);
      } else {
        document.body?.classList.add(className);
      }
    });

    return () => {
      classNames.forEach(className => {
        document.body?.classList.remove(className);
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
